import { render, staticRenderFns } from "./LawExpertOpinionOutcomeList.vue?vue&type=template&id=4f7528ab&"
import script from "./LawExpertOpinionOutcomeList.vue?vue&type=script&lang=js&"
export * from "./LawExpertOpinionOutcomeList.vue?vue&type=script&lang=js&"
import style0 from "./LawExpertOpinionOutcomeList.vue?vue&type=style&index=0&id=4f7528ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports